<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">update custom release</small>
      </legend>
      <div>
        <form @submit.prevent="customreleaseUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="fileopening_id" :value="Customrelease.fileopening_id" />
              <input type="hidden" class="id" :value="Customrelease.id" />
              <div class="form-group">
                <label>Lodged date</label>
                <input
                  type="date"
                  class="form-control lodged_date input-rounded f-s-14"
                  :value="Customrelease.lodged_date"
                  placeholder="lodged date"
                />
              </div>
              <div class="form-group">
                <label>W7/T810 Entry</label>
                <input
                  type="number"
                  class="form-control t810_entry input-rounded f-s-14"
                  :value="Customrelease.t810_entry"
                  placeholder="W7/T810 entry"
                  required
                />
              </div>

              <div class="form-group">
                <label>CFS</label>
                <input
                  type="text"
                  class="form-control cfs input-rounded f-s-14"
                  :value="Customrelease.cfs"
                  placeholder="cfs"
                  required
                />
              </div>
              <div class="form-group">
                <label>C400</label>
                <input
                  type="number"
                  class="form-control c400 input-rounded f-s-14"
                  placeholder="c400"
                  :value="Customrelease.c400"
                />
              </div>
              <div class="form-group">
                <labe>IM4</labe>
                <input
                  type="number"
                  class="form-control im4 input-rounded f-s-14"
                  placeholder="im4"
                  :value="Customrelease.im4"
                />
              </div>
              <div class="form-group">
                <label>Declaration T1</label>
                <input
                  type="number"
                  class="form-control declaration_t1 input-rounded f-s-14"
                  placeholder="declaration_t1"
                  :value="Customrelease.declaration_t1"
                />
              </div>
              <div class="form-group">
                <label>Declaration W48</label>
                <input
                  type="number"
                  class="form-control declaration_wt8 input-rounded f-s-14"
                  placeholder="declaration_wt8"
                  :value="Customrelease.declaration_wt8"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>T810 expiry</label>
                <input
                  type="date"
                  class="form-control t810_expiry input-rounded f-s-14"
                  :value="Customrelease.t810_expiry"
                  placeholder="t810_expiry date"
                />
              </div>
              <div class="form-group">
                <label>Passed date</label>
                <input
                  type="date"
                  class="form-control passed_date input-rounded f-s-14"
                  :value="Customrelease.passed_date"
                  placeholder="passed date"
                />
              </div>
              <div class="form-group">
                <label>Total bond amount</label>
                <input
                  type="number"
                  class="form-control total_bond_amount input-rounded f-s-14"
                  :value="Customrelease.total_bond_amount"
                  placeholder="total bond amount"
                  required
                />
              </div>
              <div class="form-group">
                <label>Remarks</label>
                <input
                  type="text"
                  class="form-control remarks input-rounded f-s-14"
                  :value="Customrelease.remarks"
                  required
                />
              </div>
                
              <div class="form-group">
                <label>T1 Date</label>
                <input
                  type="date"
                  class="form-control t1_date input-rounded f-s-14"
                  placeholder="T1 Date"
                  :value="Customrelease.t1_date"
                  required
                />
              </div>
              <div class="form-group">
                <label>T1 Expiry date</label>
                <input
                  type="date"
                  class="form-control t1_expiry_date"
                  placeholder="t1 expiry date"
                  :value="Customrelease.t1_expiry_date"
                  required
                />
              </div>
              <div class="form-group">
                <label>Wt8 expiry days</label>
                <input
                  type="number"
                  class="form-control wt8_expirydays"
                  placeholder="wt8 expirydays"
                  :value="Customrelease.wt8_expirydays"
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingCustomrelease btn-rounded">
            <i class="fa fa-file"></i> update shipping
          </button>
          <button type="button" class="btn btn-primary btn-flat updatingCustomreleaseLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Customrelease.length === 0) {
      router.push("/managecustomreleases");
    }
  },
  computed: {
    ...mapGetters(["Customrelease"])
  },
  methods: {
    ...mapActions(["customreleaseUpdate"])
  }
};
</script>
<style scoped>
.updatingCustomreleaseLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/customreleases/updatecustomrelease.vue